import React from 'react';

import type { BrainAtlasType, MultiLang } from '../../../../config';
import ItemUtil, { type ItemBasicFile } from '../../../lib/ItemUtil';
import styles from './FileDownloadButton.module.css';
import LicenseAgreementDialog from './LicenseAgreementDialog';

interface Props {
    lang: MultiLang;
    file: ItemBasicFile;
    rights: string;
    useCc: number;
    ccCommercialUse: number;
    ccModification: number;
    type: BrainAtlasType;
}

const FileDownloadButton: React.FC<Props> = (props) => {
    const { lang, file, rights, useCc, ccCommercialUse, ccModification, type } = props;

    const [show, setShow] = React.useState<boolean>(false);

    const handleClickDownload: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
        if (rights !== '') {
            e.stopPropagation();
            e.preventDefault();
            setShow(true);
        }
    };

    const url = ItemUtil.getFileUrl(type, file);
    return (
        <>
            <a
                className={styles.downloadButton}
                href={url}
                download={file.original_file_name}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClickDownload}
            >
                Download
            </a>
            <LicenseAgreementDialog
                lang={lang}
                file={file}
                rights={rights}
                useCc={useCc}
                ccCommercialUse={ccCommercialUse}
                ccModification={ccModification}
                show={show}
                unsetShow={() => setShow(false)}
                type={type}
            />
        </>
    );
};

export default FileDownloadButton;
